/*
 * Copyright (C) 2012-2025 Johan Legrand <johan.legrand@sync-in.com>
 * This file is part of Sync-in | The open source file sync and share solution
 * See the LICENSE file for licensing details
 */

export * from '../cache/schemas/mysql-cache.schema'
export * from '../../applications/users/schemas/users.schema'
export * from '../../applications/users/schemas/groups.schema'
export * from '../../applications/users/schemas/users-groups.schema'
export * from '../../applications/users/schemas/users-guests.schema'
export * from '../../applications/spaces/schemas/spaces.schema'
export * from '../../applications/spaces/schemas/spaces-members.schema'
export * from '../../applications/spaces/schemas/spaces-roots.schema'
export * from '../../applications/shares/schemas/shares.schema'
export * from '../../applications/shares/schemas/shares-members.schema'
export * from '../../applications/files/schemas/files.schema'
export * from '../../applications/files/schemas/files-recents.schema'
export * from '../../applications/links/schemas/links.schema'
export * from '../../applications/comments/schemas/comments.schema'
export * from '../../applications/notifications/schemas/notifications.schema'
export * from '../../applications/sync/schemas/sync-clients.schema'
export * from '../../applications/sync/schemas/sync-paths.schema'
